import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import {
  setPerformanceChildCreateAction,
  setPerformanceUpdateChildAction,
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

import Swal from "sweetalert2";

function PerformanceChildPopup(props) {
  const {
    show,
    setShow,
    editPayload,
    refresh,
    selectedPerformanceParentId,
    setEditPayload,
    search,
  } = props;
  const [grading_name, setGrading_name] = useState("");
  const [editValidate, setEditValidate] = useState({});
  const [description, setDescription] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const Swal = require("sweetalert2");

  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (Object.keys(editPayload).length > 0) {
      const payload = {
        data: {
          grading_name: grading_name,
          description: description,
          parent_id: selectedPerformanceParentId.id,
        },
        id: editPayload.id,
        parent_id: selectedPerformanceParentId.id,
        search: search == undefined ? "":search,
      };
      dispatch(setPerformanceUpdateChildAction(payload));
    } else {
      const payload = {
        data: {
          grading_name: grading_name,
          description: description,
          parent_id: selectedPerformanceParentId.id,
        },
        search: search == undefined ? "":search,
      };
      dispatch(setPerformanceChildCreateAction(payload));
    }
    setEditPayload("");
    setGrading_name("");
    setDescription("");
    setShow(false);
  };
  useEffect(() => {
    if (Object.keys(editPayload).length > 0) {
      setEditValidate(editPayload);
      setEditMode(true);
      setGrading_name(editPayload.grading_name);
      setDescription(editPayload.description);
    }
  }, [editPayload]);
  const handleClose = () => {
    const hasdata = Object.keys(editPayload).length > 0 ?  true : grading_name != "";
  if(hasdata ){
    Swal.fire({
      title: `Do you want to exit  Criteria Type ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        // setShow(false);
        setEditPayload("");
        setGrading_name("");
        setDescription("");
        setShow(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  }
  else {
        setEditPayload("");
        setGrading_name("");
        setDescription("");
        setShow(false);
  }
  };
  //   useEffect(() => {
  //     if (Object.keys(editPayload).length > 0) {
  //       if (
  //         grading_name.length === 0 ||
  //         grading_name == editValidate.grading_name
  //       ) {
  //         setIsDirty(true);
  //       } else if (
  //         description.length === 0 ||
  //         description == editValidate.description
  //       ) {
  //         setIsDirty(true);
  //       } else {
  //         setIsDirty(false);
  //       }
  //     }
  //   }, [grading_name, description]);
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      className="modelman"
    >
      <Modal.Header className="popHead">
        <Modal.Title>
          {Object.entries(editPayload).length > 0
            ? "Criteria Type"
            : "Criteria Type"}
        </Modal.Title>
        <div className="CloseIcon" onClick={handleClose}>
          <CloseOutlinedIcon />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="grading_name">
            Grading Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="grading_name"
            onChange={(e) => {
              setGrading_name(e.target.value);
              setIsDirty(true);
            }}
            value={grading_name}
          />
          <label htmlFor="description" className="mt-4">
            Description
          </label>
          <input
            type="text"
            className="form-control"
            id="description"
            onChange={(e) => {
              setDescription(e.target.value);
              setIsDirty(true);
            }}
            value={description}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="RoleButton">
          <button
            class="btn  SaveBtn"
            type="submit"
            onClick={handleSubmit}
            disabled={
              grading_name.length > 0 && description.length > 0 && isDirty
                ? false
                : true
            }
          >

            {Object.entries(editPayload).length > 0 ? "Update" : "Create"}
          </button>
          <button class="btn CancelBtn" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default PerformanceChildPopup;
